
import { CreateElement } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { VEditDialog } from "vuetify/lib";

@Component({ inheritAttrs: false })
export default class ReplayEditDialog extends Vue {
  @Prop(Boolean) replay!: boolean;

  render(h: CreateElement) {
    const content = this.$scopedSlots.default?.({}) || this.$slots.default;
    if (this.replay) return h("div", content);
    const input = this.$scopedSlots.input?.({}) || this.$slots.input;
    // Render functions need an explicit import; VEditDialog reads ordinary slots.
    // Vue extracts child props by deleting them from attrs; preserve ours across slot updates.
    return h(VEditDialog, { attrs: { ...this.$attrs }, on: this.$listeners }, [content, h("template", { slot: "input" }, input)]);
  }
}
